import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/cn";
import { inputClass } from "./input";

/** Native select, styled. Native keeps mobile pickers and a11y perfect. */
export const NativeSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement> & { selectSize?: "sm" | "md" }>(function NativeSelect(
  { className, children, selectSize = "md", ...props },
  ref,
) {
  return (
    <div className="relative">
      <select ref={ref} className={cn(inputClass, selectSize === "sm" ? "h-9 text-sm" : "h-11", "appearance-none pr-10", className)} {...props}>
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-slate-400" aria-hidden="true" />
    </div>
  );
});
